import { HTMLTable, Classes, Icon, Colors, Tooltip, PopoverPosition } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import * as React from 'react'
import { UprightStyle } from '../../../types'
import { PreferredItemTag } from './PreferredItemTag'
import { LoadingRow } from '../../../components/LoadingRow'
import { ManifestPreferredItem } from '../../../types/api'

interface Props {
  items: ManifestPreferredItem[]
  loading?: boolean
  onSelectItem: (item: ManifestPreferredItem) => void
}

const styles: UprightStyle = {
  fullWidth: {
    width: '100%'
  },
  tableCellCenter: {
    verticalAlign: 'middle'
  },
  tagCell: { textAlign: 'right' },
  expandCell: { width: '16px' }
}

const Expand = props => {
  const { hasDetails } = props
  if (hasDetails) {
    return (
      <Tooltip
        content="Click for more details on this item preference"
        modifiers={{ preventOverflow: { enabled: false }, flip: { enabled: false } }}
        position={PopoverPosition.LEFT}
      >
        <Icon color={Colors.GRAY3} icon={IconNames.MAXIMIZE} />
      </Tooltip>
    )
  }
  return <></>
}

export const PreferredItemTable: React.FC<Props> = props => {
  return (
    <HTMLTable compact interactive style={styles.fullWidth} striped={!props.loading}>
      <tbody>
        {props.loading && (
          <>
            <LoadingRow columnCount={3} />
            <LoadingRow columnCount={3} />
          </>
        )}
        {!props.loading &&
          props.items.map(item => {
            const onClickRow = () => props.onSelectItem(item)
            return (
              <tr key={`item-${item.id}`} onClick={onClickRow}>
                <td style={styles.expandCell}>
                  <Expand hasDetails={!!item.description} />
                </td>
                <td style={styles.tableCellCenter} className={Classes.TEXT_SMALL}>
                  <div>{item.title}</div>
                </td>
                <td style={styles.tagCell}>
                  <PreferredItemTag preference={item.preference} />
                </td>
              </tr>
            )
          })}
      </tbody>
    </HTMLTable>
  )
}
